export const UTILIDADES_TIPOS_PAGO_LISTA = 'UTILIDADES_TIPOS_PAGO_LISTA';
export const UTILIDADES_TIPOS_PAGO_LOADING = 'UTILIDADES_TIPOS_PAGO_LOADING';
export const UTILITIES_ORDERS_STATES = 'UTILITIES_ORDERS_STATES';
export const UTILITIES_BRANCH_STATES = 'UTILITIES_BRANCH_STATES';
export const UTILITIES_CATEGORIES = 'UTILITIES_CATEGORIES';
